import React from "react";

import img1 from "../../../images/directions-1.jpg";
import img2 from "../../../images/directions-2.jpg";
import img3 from "../../../images/directions-3.jpg";
import img4 from "../../../images/directions-4.jpg";

export default function Directions() {
  return (
    <section className="directions">
      <div className="directions__description">
        <h2 className="directions__title">Направления работ</h2>
        {/* <div className="directions__work">
          <h4 className="directions__text">
            Научно-исследовательские разработки
          </h4>
          <h4 className="directions__text">Лечебно-диагностическая помощь</h4>
          <h4 className="directions__text">
            Разработка медицинских и организационных технологий
          </h4>
          <h4 className="directions__text">Образование</h4>
        </div> */}
      </div>
      <div className="directions__blocks">
        <div className="directions__block">
          <img src={img1} alt="Лаборатория" className="directions__image"></img>
          <div className="directions__more">
            <h4 className="directions__more-title">
              Научно-исследовательские разработки
            </h4>
            <p className="directions__more-text">
              Основа деятельности института, направленная на поиск новых знаний
              в области медицины и здравоохранения
            </p>
            <h4 className="directions__more-title">
              <a href="/science/research" className="directions__more-link">
                Подробнее →
              </a>
            </h4>
          </div>
        </div>
        <div className="directions__block">
          <img src={img2} alt="Лаборатория" className="directions__image"></img>
          <div className="directions__more">
            <h4 className="directions__more-title">
              Лечебно-диагностическая помощь
            </h4>
            <p className="directions__more-text">
              Комплексное обследование и лечение пациентов, включая проведение
              различных диагностических исследований
            </p>
            <h4 className="directions__more-title">
              <a href="/clinic/hospital" className="directions__more-link">
                Подробнее →
              </a>
            </h4>
          </div>
        </div>
        <div className="directions__block">
          <img src={img3} alt="Лаборатория" className="directions__image"></img>
          <div className="directions__more">
            <h4 className="directions__more-title">
              Разработка медицинских и организационных технологий
            </h4>
            <p className="directions__more-text">
              Создание и внедрение новых методов диагностики, лечения и
              профилактики заболеваний
            </p>
            <h4 className="directions__more-title">
              <a href="/science/development" className="directions__more-link">
                Подробнее →
              </a>
            </h4>
          </div>
        </div>
        <div className="directions__block">
          <img src={img4} alt="Лаборатория" className="directions__image"></img>
          <div className="directions__more">
            <h4 className="directions__more-title">Образование</h4>
            <p className="directions__more-text">
              Аспирантура (31.06.01)<br></br>Ординатура (31.08.32)<br></br>{" "}
              Дополнительное профессиональное образование
            </p>
            <h4 className="directions__more-title">
              <a href="/education" className="directions__more-link">
                Подробнее →
              </a>
            </h4>
          </div>
        </div>
      </div>
    </section>
  );
}
